{
  "settings": "設定",
  "yourDigitalAssistant": "智能客服",
  "getStarted": "開始使用",
  "login": "登錄",
  "loggingIn": "登錄中",
  "darkMode": "夜間模式",
  "clearHistory": "清除歷史記錄",
  "historyCleared": "歷史紀錄已清除",
  "changeLanguage": "語言",
  "termsAndConditions": "條款及細則",
  "messagePlaceholder": "在這裡輸入你的訊息 ...",
  "messagePlaceholderDisabled": "無法輸入...",
  "feedbackTitle": "請評價您的體驗",
  "feedbackPlaceholder": "請提供您的意見(選填)",
  "feedbackSend": "發送",
  "feedbackClose": "關",
  "sessionExpired": "尚未收到您的訊息，對話已先暫停",
  "startNewSession": "開始新的對話",
  "apiError": "很抱歉！系統異常，我們正努力修復中。",
  "apiErrorOffline": "您未連線至網路。",
  "tryAgain": "再試一次",
  "startOver": "重新開始",
  "chatEnded": "聊天已結束。",
  "chatEndedThankYou": "感謝您與我們聊天！",
  "closeChat": "關",
  "startNewChat": "再聊一次",
  "humanTakeoverStarted": "為您轉接客戶服務專員中",
  "humanTakeoverQueued": "客服專員忙線中，請稍候",
  "humanTakeoverAnAgent": "線上客服專員",
  "humanTakeoverAgentEntered": "進入對話",
  "humanTakeoverAgentLogout": "已離開對話",
  "humanTakeoverTransfer": "將為您轉接另一位服務專員",
  "humanTakeoverEnded": "您正在與智能客服對話",
  "version": "版本",
  "formIntroText": "請填寫以下表格, 開始與客服對話。",
  "formFirstName": "名字",
  "formLastName": "姓氏",
  "formName": "名稱",
  "formEmail": "電子郵件",
  "formWrongEmail": "請提供有效的電子郵件地址。",
  "formPhone": "電話",
  "formShipmentId": "貨件提單號碼",
  "formQuestion": "您的問題",
  "formAccountNumber": "帳號（針對企業客戶）",
  "formAddress": "地址",
  "formPostcode": "邮政编码",
  "formCity": "市",
  "formCountry": "国家",
  "formSubmitButton": "開始對話",
  "formEmptyFieldError": "必填欄位",
  "formPhoneNumberValidationError": "無效的電話號碼。",
  "formInputIsBiggerThan50": "上限為 50個字元",
  "formInputIsBiggerThan100": "上限為 100個字元",
  "formInputIsBiggerThan2000": "上限為 2000個字元",
  "widgetEventOnline": "DA消息：用戶重新聯機。",
  "widgetEventHidden": "DA消息：窗口小部件已隱藏。",
  "widgetEventVisible": "DA消息：窗口小部件可見。",
  "widgetEventVisibleMinimized": "DA消息：窗口小部件可見，但已最小化。",
  "widgetEventMinimized": "DA消息：小部件已最小化。",
  "widgetEventMaximized": "DA消息：小部件已最大化。",
  "widgetEventSessionExpired": "DA消息：窗口小部件會話已過期。",
  "widgetEventHangupHuman": "DA 消息：用戶結束人工接管會話。",
  "widgetEventUserTyping": "DA消息：用戶正在輸入。",
  "fileTooLarge": "您正在嘗試附加太大的文件。",
  "tooManyDiles": "您正在嘗試附加太多文件。",
  "fileInvalidType": "您正在嘗試附加無效的文件類型。",
  "attachmentsDropHere": "放在這裡上傳或",
  "attachmentsBrowse": "瀏覽文件",
  "attachmentsExtenstionQuantity": "pdf或圖像（最多10個文件）",
  "attachmentsSize": "高達30 MB",
  "attachmentsFailedUploading": "上載失敗",
  "attachmentsUploading": "上載中...",
  "minimizeExpandText": "立即与我们实时聊天！",
  "popupWidgetNotificationMessage": "您收到一条新消息！",
  "tabWidgetNotificationMessage": "新消息！",
  "datepickerSendButton": "发送"
}
